/**
 * i18n Composable
 * 用于在 Vue 组件中方便地使用国际化功能
 */

import { computed } from 'vue'
import i18n, { type LocaleCode, setLocale } from '@/i18n'

export function useI18n() {
  /**
   * 翻译文本
   * @param key - 翻译的 key
   * @param params - 替换参数
   */
  const t = (key: string, params?: Record<string, any>) => {
    return i18n.t(key, params) as string
  }

  /**
   * 当前语言代码
   */
  const locale = computed({
    get: () => i18n.locale as LocaleCode,
    set: (value: LocaleCode) => setLocale(value),
  })

  /**
   * 切换语言
   */
  const changeLocale = (newLocale: LocaleCode) => {
    setLocale(newLocale)
  }

  return {
    t,
    locale,
    changeLocale,
  }
}
